import SubadminSimpleForm from './SubadminSimpleForm'

export default SubadminSimpleForm
